import { render } from "./ModalHowToAccess.vue?vue&type=template&id=c75ce292&scoped=true"
import script from "./ModalHowToAccess.vue?vue&type=script&lang=js"
export * from "./ModalHowToAccess.vue?vue&type=script&lang=js"

import "./ModalHowToAccess.vue?vue&type=style&index=0&id=c75ce292&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75ce292"]])

export default __exports__